import type { ModuleEntityItem } from "../../../types";
import { jsCollectionIdURL } from "ee/RouteBuilder";

export const getJSModuleEntityItemUrl = (item: ModuleEntityItem): string => {
  return jsCollectionIdURL({
    baseCollectionId: item.key,
    baseModuleId: item.moduleId,
  });
};
